/* eslint-disable react/prop-types */ // TODO: add props
import { Component } from 'react';
import { connect } from 'react-redux';
import invariant from 'invariant';
import LoadingIndicator from 'edrolo/domains/app/components/LoadingIndicator';
import { actions as contentActions } from 'edrolo/reducers/content';
import createLessonContentSelectors from 'edrolo/selectors/bound/createLessonContentSelectors';

const mapStateToProps = (state, ownProps) => {
  const lessonId = ownProps?.match?.params?.lessonId;
  const lessonSelectors = createLessonContentSelectors(lessonId);
  return {
    lessonId,
    lesson: lessonSelectors.getLesson(state),
    chunks: lessonSelectors.getLessonChunks(state),
  };
};

const mapDispatch = (dispatch, ownProps) => ({
  loadLesson: () =>
    dispatch(
      contentActions.loadLesson.signal(ownProps?.match?.params?.lessonId)
    ),
});

export default function lessonRouteLoader(WrappedComponent) {
  @connect(mapStateToProps, mapDispatch)
  class LessonRouteLoader extends Component {
    componentDidMount() {
      invariant(
        this.props.lessonId,
        'lessonRouteLoader only works on a route with a :lessonId route parameter'
      );
      global.ifDev(`loading lesson ${this.props.lessonId}`);
      this.props.loadLesson(this.props.lessonId);
    }

    render() {
      const { lesson } = this.props;
      return !lesson ? (
        <LoadingIndicator loadingText={'Loading Lesson'}>
          <WrappedComponent {...this.props} />
        </LoadingIndicator>
      ) : (
        <WrappedComponent {...this.props} />
      );
    }
  }

  return LessonRouteLoader;
}
